<template>
  <v-flex class="container-card-item">
    <v-hover v-slot="{ hover }">
      <v-card :elevation="hover ? 5 : 2" class="item">
        <div class="container-painel-usuario">
          <div class="container-header">
            <foto-avatar :foto-url="value.foto" class-avatar="imagem-dentista"/>
          </div>
          <div class="container-detalhes">
            <span class="text-info-nome d-inline-block d-inline-block text-truncate max-width-item">{{
                value.nome | textoSemValor
              }}</span><br/>
            <span class="d-inline-block d-inline-block text-truncate max-width-item">{{
                value.login | textoSemValor
              }}</span>
          </div>
        </div>
        <v-overlay :value="hover" absolute>
          <div>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="editarUsuario" icon class="mr-5">
                  <v-icon size="18">fas fa-pen</v-icon>
                </v-btn>
              </template>
              Editar usuário
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <v-btn v-on="on" @click="inserirPermissoes" icon>
                  <v-icon size="20">fas fa-user-shield</v-icon>
                </v-btn>
              </template>
              Gerenciar permissões
            </v-tooltip>
          </div>
        </v-overlay>
      </v-card>
    </v-hover>
  </v-flex>
</template>

<script>
import FotoAvatar from '@/views/components/FotoAvatar.vue'

export default {
    name: 'GerenciarUsuarioItem',
    components: {FotoAvatar},
    props: {
        value: {
            default: () => {
                return {}
            },
        },
        index: {
            type: Number,
        },
    },
    methods: {
        editarUsuario() {
            this.$emit('editarUsuario', this.value)
        },
        inserirPermissoes() {
            this.$emit('permissaoUsuario', this.value)
        },
    }
}
</script>


<style scoped lang="stylus">

.container-card-item
  float left
  display inline-flex
  margin-right 10px
  margin-top 10px

.item
  width 300px
  border 1px solid #d9d9d9

.text-info-nome
  font-weight 600
  font-size 20px

.container-painel-usuario
  color #777
  padding 10px
  height 120px
  display flex
  overflow hidden

.container-header
  margin-right 5px

.max-width-item
  max-width 190px

.imagem-dentista
  height 90px
  width 90px
  border-radius 50%
  border 2px solid #eee
  align-self center

</style>